import Vue from 'vue'
import Url from '../zujian/Url.vue' 
Vue.component(Url.name,Url);
import Tijiao from '../zujian/Tijiao.vue' 
Vue.component(Tijiao.name,Tijiao);

//设置域名
// Vue.prototype.$yuming='limitao.myuan.cn';	
// Vue.prototype.$url='https://limitao.myuan.cn/shanghu.php?d=33';
Vue.prototype.$yuming='xcx.fubetter.com';	//正式 
// Vue.prototype.$yuming='x.fubetter.com';	//正式 

Vue.prototype.$url='https://xcx.fubetter.com/shanghu.php?d=33';
// Vue.prototype.$url='https://x.fubetter.com/shanghu.php?d=33';
Vue.prototype.$tengxunditu='43BBZ-26IK5-ER3IV-QK32L-ZWHIO-HJFAA';
 Vue.prototype.$post=function(_url,shu,fun,urls){
	var that=this;
	var url =this.$url+'&'+_url;
	if(urls){
		url=urls+'&'+_url;
	}else{
		if(that.$qu('urlss')!=''){
			// console.log(that.$qu('urlss'))
			url =that.$qu('urlss')+'&'+_url;
		}
	}
	// console.log('hyid='+that.$qu('hyid'));
	// console.log('$shanghu='+that.$shanghu.kouling);
	if(typeof(shu)=='function'){
		fun=shu;
		shu={}; 
	}
	this.$axios({
	    method:'POST',
	    url:url,
	    data:shu,	  
	    headers:{			
			'kouling':that.$shanghu?that.$shanghu.kouling:''
		},	
	}).then(function(res){
		console.log(res)
		if(res.data.shi==-1){
			that.$dakai('denglu');
		}else if(res.data.shi==-100){
			if(!that.__zhixing){
				that.__zhixing=true;
				that.$xiaoxi(res.data.shu);	
				setTimeout(function(){
					that.__zhixing=false;
				},1000)
				that.$dakai('denglu');
			}			
		
		}else{
			fun(res.data);
		}
	    
	}).catch(function(err){
	    console.log(err);
	})
 }

 Vue.prototype.$qu=function(key){	
    return JSON.parse(localStorage.getItem(key)) || [];
 }
 Vue.prototype.$cun=function(key,value){	
    return localStorage.setItem(key,JSON.stringify(value)) || '';
 }
 Vue.prototype.$dakai=function(url){
    return this.$router.push(url).catch(err => {}) ;
 }
  Vue.prototype.$houtui=function(e){
	if(!e){
		e=-1;
	}
	return this.$router.go(e);
 }
 
 Vue.prototype.$xiaoxi=function(message,leixing){	
	if(leixing===0){
		return this.$message.error(message);
	}else{
		return this.$message(message);
	}   
 }
 Vue.prototype.$suijizifu=function(len) {
　　len = len || 32;
　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
　　var maxPos = $chars.length;
　　var pwd = '';
　　for (var i = 0; i < len; i++) {
　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
　　}
　　return pwd;
}
 Vue.prototype.$quanju=function(jianzhi,zhi) {
	 if(jianzhi){
		if(!zhi)zhi=''; 
		 Vue.prototype[jianzhi]=zhi; 
	 }	 
}
 Vue.prototype.$biaoti=function(biaoti){
	if(biaoti){
		document.title =biaoti;
	}
	
}
